let cacheSignature = null;
let cacheResult = new Set();

const buildSignature = (fields) => {
  let signature = "";

  for (const id in fields) {
    const f = fields[id];
    signature += `${id}:${f.slug || ""}:${f.toBeDeleted ? 1 : 0}|`;
  }

  return signature;
};

const computeDuplicated = (fields) => {
  const counts = new Map();
  const dup = new Set();

  for (const id in fields) {
    const f = fields[id];

    if (!f.slug || f.toBeDeleted === true) continue;

    const next = (counts.get(f.slug) || 0) + 1;
    counts.set(f.slug, next);

    if (next > 1) dup.add(f.slug);
  }

  return dup;
};

const useDuplicatedSlugs = (fields) => {
  const signature = buildSignature(fields);

  if (signature !== cacheSignature) {
    cacheSignature = signature;
    cacheResult = computeDuplicated(fields);
  }

  return cacheResult;
};

export default useDuplicatedSlugs;
